<template>
    <Pagebody :loading='loading' :subnav="$store.getters.subnavNames">
        <innerFill />
    </Pagebody>
</template>

<script>
    // @ is an alias to /src
    import innerFill from './innerFill'
    import store from '@/store/sub_detail/'
    export default {
        name: 'Detail',
        data: ()=>({
            loading: false
        }),
        provide () {
            let self = this
            return {
                setLoading (x) {
                    self.loading = x
                }
            }
        },
        components: {
            innerFill
        },
        watch: {
            '$route.params.id': {
                handler (val,old) {
                    
                },
                immediate: true
            }
        }
    }
</script>

